import Projectiles from '../entities/Projectiles';
export const getProjectile = (name) => {
    if (name in Projectiles) {
        return Projectiles[name];
    }
    throw new Error(`${name} projectile not found`);
};
export const contentNotFound = (type, id) => {
    throw new Error(`${type} ${id} not found`);
};
export const typeCheckContent = (id, item, kind) => {
    if ((item === null || item === void 0 ? void 0 : item.kind) !== kind) {
        throw new Error(`${kind} ${id} has an invalid type`);
    }
    return item;
};
export const trimComicId = (id) => {
    return id.includes('WBM') ? id.slice(0, 3) + id.slice(5) : id;
};
//# sourceMappingURL=index.js.map